import Reveal from './Reveal'
import { publicCases } from '../content/work'

export default function Work() {
  return (
    <section id="work" aria-labelledby="work-title" className="bg-mariner text-white py-24 md:py-32">
      <div className="container mx-auto px-6">
        <Reveal>
          <p className="site-label text-vault">02 · Selected work</p>
          <h2 id="work-title" className="site-display text-4xl md:text-5xl mt-5 max-w-3xl">
            Systems that carry real money, real customers and real load.
          </h2>
          <p className="text-mist mt-6 max-w-2xl leading-relaxed">
            Client work stays private under our agreements. These are the builds we can show today, with their sector, stack and results.
          </p>
        </Reveal>

        <Reveal>
          <ol className="mt-16 border-t border-ledger">
            {publicCases.map((c, i) => (
              <li key={c.id} className="grid lg:grid-cols-12 gap-6 lg:gap-10 py-10 border-b border-ledger">
                <div className="lg:col-span-1">
                  <span className="site-label text-vault">{String(i + 1).padStart(2, '0')}</span>
                </div>
                <div className="lg:col-span-6">
                  <p className="site-label text-mist">{c.sector}</p>
                  <h3 className="font-brandSerif font-semibold text-2xl md:text-3xl mt-3">{c.title}</h3>
                  <p className="text-base text-mist leading-relaxed mt-4 max-w-2xl">{c.summary}</p>
                  <ul className="flex flex-wrap gap-2 mt-6" aria-label="Technologies used">
                    {c.stack.map((t) => (
                      <li key={t} className="font-brandMono text-[12px] text-mist border border-ledger px-2.5 py-1 rounded-sm">
                        {t}
                      </li>
                    ))}
                  </ul>
                </div>
                <dl className="lg:col-span-5 grid grid-cols-1 gap-5 lg:pl-8 lg:border-l border-ledger">
                  {c.results.map((r) => (
                    <div key={r.label} className="flex flex-col-reverse">
                      <dt className="text-sm text-mist mt-1">{r.label}</dt>
                      <dd className="font-brandMono text-2xl text-vault tabular-nums">{r.value}</dd>
                    </div>
                  ))}
                </dl>
              </li>
            ))}
          </ol>
        </Reveal>
      </div>
    </section>
  )
}
